module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h1', {
    attrs: {
      "id": "aid-1T141"
    }
  }, [_vm._v("Bonjour, Y’all")]), _c('div', {
    staticClass: "toc"
  }, [_c('p', [_c('b', [_vm._v("Table of Contents")])]), _c('dl', [_c('dt', [_c('span', {
    staticClass: "chapter"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/part0003#aid-2RHM2"
    }
  }, [_vm._v("History of Croissants Bistro & Bakery")])])]), _c('dt', [_c('span', {
    staticClass: "chapter"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/part0004",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Libations ")])])]), _c('dd'), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/part0004#d0e254",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Carolina Lemonade ")])])]), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/part0004#d0e279",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Banana Cream Pie ")])])]), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/part0004#d0e302",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Gary’s Cosmo ")])])]), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/part0004#d0e331",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Watermelon Freeze ")])])]), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/part0004#d0e352",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chocolate Martini ")])])]), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/part0004#d0e375",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Chartier ")])])]), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/part0004#d0e396",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Cucumber Martini ")])])]), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/part0004#d0e421",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("South Carolina Peach and Blueberry Sangria ")])])])]), _c('span', {
    staticClass: "chapter"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/part0005#aid-4OIQ2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Breads ")])]), _c('dl', [_c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/part0005#d0e462",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Lavash ")])])]), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/part0005#flat",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Flatbread ")])])]), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/part0005#bread",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("French Bread ")])])]), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/part0005#challah",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Challah Bread ")])])]), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/part0005#rye",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Rye Bread ")])])])]), _c('span', {
    staticClass: "chapter"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/part0006#aid-5N3C2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Starters ")])]), _c('dl', [_c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/part0006#d0e727",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Crab Cakes ")])])]), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/part0006#d0e788",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Gruyère Puffs ")])])]), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/part0006#d0e839",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("French Onion Soup ")])])]), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/part0006#d0e889",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Butternut Squash Soup ")])])]), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/part0006#d0e931",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("She Crab Soup ")])])]), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/part0006#d0e977",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Heirloom Tomato Salad ")])])]), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/part0006#d0e1023",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Watermelon Salad ")])])])]), _c('span', {
    staticClass: "chapter"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/part0007#aid-6LJU2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Main ")])]), _c('dl', [_c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/part0007#d0e1087",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Shrimp and Grits ")])])]), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/part0007#d0e1197",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Scallops Benton ")])])]), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/part0007#d0e1300",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Pan-Seared Grouper ")])])]), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/part0007#d0e1408",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Angry Bulls Bay Clams ")])])]), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/part0007#d0e1461",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Bistro Chicken ")])])]), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/part0007#d0e1590",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Peach Pork Tenderloin ")])])])]), _c('span', {
    staticClass: "chapter"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/part0008#aid-7K4G2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Brunch ")])]), _c('dl', [_c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/part0008#d0e1712",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Smothered Grits ")])])]), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/part0008#d0e1761",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Granola ")])])]), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/part0008#d0e1817",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Bananas Foster French Toast ")])])]), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/part0008#d0e1930",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Croque Monsieur / Croque Madame ")])])]), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/part0008#d0e2014",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Strawberry Crepes / Banana and Nutella Crepes ")])])]), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/part0008#d0e2113",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Artichoke and Pimento Cheese Sandwich ")])])]), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/part0008#d0e2162",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Ham, Apple, and Brie Melt ")])])]), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/part0008#d0e2200",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Monte Cristo ")])])]), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/part0008#d0e2246",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Caprese Flatbread ")])])]), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/part0008#d0e2288",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Fresh Peach and Prosciutto Flatbread ")])])])]), _c('span', {
    staticClass: "chapter"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/part0009#aid-8IL22",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Cookies ")])]), _c('dl', [_c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/part0009#d0e2366",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Roz’s Chocolate Chip Cookies ")])])]), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/part0009#d0e2420",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Croissants’ Signature Brownies ")])])]), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/part0009#d0e2470",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Lemon Squares ")])])]), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/part0009#d0e2552",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Grandma Erb’s Molasses Cookies ")])])]), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/part0009#d0e2604",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Double Chocolate Chip Cookies ")])])]), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/part0009#d0e2657",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Coconut Macaroons ")])])]), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/part0009#d0e2701",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("French Macarons ")])])])]), _c('span', {
    staticClass: "chapter"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/part0010#aid-9H5K2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Encore ")])]), _c('dl', [_c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/part0010#d0e2808",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Coconut Custard Cake ")])])]), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/part0010#d0e2948",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Triple Chocolate Mousse ")])])]), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/part0010#d0e3077",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Blueberry and Raspberry Tart ")])])]), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/part0010#d0e3161",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Black Forest Torte ")])])]), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/part0010#d0e3331",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Pumpkin Cheesecake ")])])]), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/part0010#d0e3392",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Grandma Schreiner’s Chocolate Log ")])])]), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/part0010#d0e3486",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Roz’s Carrot Cake ")])])]), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/part0010#d0e3581",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Key Lime Tart ")])])])]), _c('span', {
    staticClass: "chapter"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/part0011#aid-AFM62",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Pantry ")])]), _c('dl', [_c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/part0011#btjam",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Bacon and Tomato Jam ")])])]), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/part0011#balsamic",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Balsamic Reduction ")])])]), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/part0011#bstock",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Beef Stock ")])])]), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/part0011#demi",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Beef Demi-Glace ")])])]), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/part0011#cheese",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Gournay Cheese ")])])]), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/part0011#chicks",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chicken Stock ")])])]), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/part0011#sauce",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Classico Sauce ")])])]), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/part0011#cgrits",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Grits ")])])]), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/part0011#hhock",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Ham Hock Jus ")])])]), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/part0011#mornay",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Mornay Sauce ")])])]), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/part0011#pimento",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Pimento Cheese ")])])]), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/part0011#peach",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Peach BBQ Sauce ")])])]), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/part0011#tzat",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Tzatziki Dressing ")])])])]), _c('span', {
    staticClass: "chapter"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/part0012#aid-BE6O2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Future of Food in Myrtle Beach ")])]), _c('span', {
    staticClass: "chapter"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/part0013#aid-CCNA1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Acknowledgments ")])]), _c('span', {
    staticClass: "chapter"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/part0014#aid-DB7S1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("About the Author")])]), _c('span', {
    staticClass: "chapter"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/part0015#aid-E9OE1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Metric Conversion Chart")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7ecd1c16","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/part0002.vue
// module id = 63
// module chunks = 0